/* Stylesheet */

.list_toolbar {
  display: flex;
  height: 52px;
  align-items: center;
  justify-content: space-between;
  background: var(--ion-gradient-light);
  border-radius: 5px 5px 0px 0px;

  .flex_container {
    display: flex;
    gap: 12px;
  }
}
